import AddIcon from "@mui/icons-material/Add";
import MainFrame from "../../components/mainFrame";
import { Box, Button, IconButton, TableRow } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../components/table";
import Navbar from "../../components/navbar";
import { Cell } from "../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useModal } from "../../components/modal";
import { DeleteModal } from "../../components/appbar/modal";
import { Helmet } from "react-helmet";
import { smallButton } from "../../components/Button";
import getImageLink from "../../utils/getImageLink";
import { AddModal } from "./modal";
import {
  useDeleteOrganMutation,
  useGetOrgansQuery,
} from "../../app/services/organ.api";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});
function Organs() {
  const { setShow, setContent } = useModal();
  const [query, setQuery] = useState<{ page?: number; size?: number }>({
    page: 0,
    size: 10,
  });
  const { data, isLoading, isFetching } = useGetOrgansQuery(query);
  const navigate = useNavigate();
  const [deleteOrgan] = useDeleteOrganMutation();
  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      const organ = data?.organs?.entities[id];
      if (!organ) return;
      setContent({
        title: " ویرایش سازمان",
        body: <AddModal defaultValue={organ} />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف سازمان",
        // removes the organ account, its memberships, course grants and pending phones
        body: (
          <DeleteModal
            handleDelete={() => {
              deleteOrgan(id)
                .unwrap()
                .then(() => setShow(false))
                .catch(() => {});
            }}
          />
        ),
      });
    }
    if (type === "add") {
      setContent({
        title: "افزودن سازمان",
        body: <AddModal />,
      });
    }
    setShow(true);
  }

  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> سازمان ها | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="سازمان ها">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن سازمان
        </Button>
      </Navbar>
      <StickyTable
        headers={[
          { name: "تصویر" },
          { name: "عنوان" },
          { name: "شماره تماس" },
          { name: "توضیحات" },
        ]}
        length={data?.length ?? 0}
        operations={true}
        isLoading={isLoading || isFetching}
        onPageQueryChange={(q) => setQuery((prev) => ({ ...prev, ...q }))}
      >
        {data?.organs?.ids?.map((id, indx) => {
          const organ = data?.organs.entities[id];
          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={id}
              sx={{ cursor: "pointer" }}
              onClick={() => navigate(`/organs/${id}/members`)}
            >
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>
                {organ.profile ? (
                  <img
                    width={"10%"}
                    height={"10%"}
                    alt="profile"
                    src={getImageLink(organ.profile)}
                  />
                ) : (
                  "not set"
                )}
              </Cell>
              <Cell>{organ.name}</Cell>
              <Cell>{organ.phone}</Cell>
              <Cell width="30%">{organ.desc}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={() => handleOpenModal("edit", id)}>
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton onClick={() => handleOpenModal("delete", id)}>
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Organs);
